export default {
  defaultHourlyRate: 'Default Hourly Rate',
  updateCostRate: 'Update Cost Rate',
};
